import { render, staticRenderFns } from "./JobSearchPage.vue?vue&type=template&id=6f1b9277&lang=pug&"
import script from "./JobSearchPage.vue?vue&type=script&lang=ts&"
export * from "./JobSearchPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f1b9277')) {
      api.createRecord('6f1b9277', component.options)
    } else {
      api.reload('6f1b9277', component.options)
    }
    module.hot.accept("./JobSearchPage.vue?vue&type=template&id=6f1b9277&lang=pug&", function () {
      api.rerender('6f1b9277', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jobsearch-pages/JobSearchPage.vue"
export default component.exports